<template>
	<AlertCardWrapper
		:alert="alert"
		allowReTakeAction
		:titleArr="titleArr"
		:actionTitle="actionTitle"
		@action-button-click="actionButtonClick"
	>
		<template #subtitle>
			<SubTitle :text="subtitleText" :icon="subtitleIcon" :iconType="subtitleIconType" />
		</template>
	</AlertCardWrapper>
</template>

<script>
import { getWorkflowData } from '@/store/modules/workflows/actions';
import { getWorkflow } from '@/store/modules/workflows/getters';
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
import { mapActions, mapGetters } from 'vuex';
import AppService from '@/utils/AppService';
import WorkflowService from '@/utils/WorkflowService';
import { getServiceBySlug } from '@/store/modules/apps/getters';
import { teamMembers } from '@/store/modules/account/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
export default {
	name: 'ModuleSharedAndTurnedOn',
	mixins: [AlertTypeBaseMixin],
	computed: {
		...mapGetters([getWorkflow.fullPath, teamMembers.fullPath]),
		...mapGettersShorthand({ getServiceBySlug }),
		title() {
			if (!this.sharingUserName || !this.relatedModule?.workflow_title) {
				return 'A feature has been shared with you';
			}
			return `${this.sharingUserName} has shared a feature with you: ${this.relatedModule?.workflow_title}`;
		},
		titleArr() {
			if (!this.sharingUserName || !this.relatedModule?.workflow_title) {
				return [{ text: 'A feature has been shared with you' }];
			}
			return [
				{ text: this.sharingUserName, isBold: true },
				{ text: 'has shared a feature with you:' },
				{ text: this.relatedModule?.workflow_title, isBold: true },
			];
		},
		actionTitle() {
			return 'Open feature details';
		},
		subtitleText() {
			return `${this.relatedModule?.onboarding_settings?.text}` || '';
		},
		subtitleIcon() {
			return AppService.getIntegrationName(this.relatedModuleContextService);
		},
		subtitleIconType() {
			return this.relatedModule?.flow_type;
		},
		sharingUserName() {
			const member = this[teamMembers.fullPath].find((member) => member.user_id === this.relatedModule?.owner);
			if (member) {
				return member.name;
			}
			return '';
		},
		relatedModuleId() {
			return this.relatedEntitiesMapByEntityType.workflow && this.relatedEntitiesMapByEntityType.workflow[0];
		},
		relatedModule() {
			return this[getWorkflow.fullPath](this.relatedModuleId);
		},
		relatedModuleContextService() {
			const serviceContextSlug = WorkflowService.getWorkflowContextServiceSlug(this.relatedModule);
			return this.getServiceBySlug(serviceContextSlug);
		},
	},
	methods: {
		...mapActions([getWorkflowData.fullPath]),
		actionButtonClick() {
			const featureDetailsUrl = `${window.location.origin}/feature-details/${this.relatedModuleId}`;
			window.open(featureDetailsUrl, '_blank');
			this.markAlertAsCompleted();
		},
		getRelatedEntities() {
			this[getWorkflowData.fullPath]({ id: this.relatedModuleId });
		},
	},
	mounted() {
		this.getRelatedEntities();
	},
};
</script>

<style lang="scss" scoped></style>
